// extracted by mini-css-extract-plugin
export default {"popup":"ocr+u","visible":"CTgvB","fade-in":"IY1xQ","fadeIn":"IY1xQ","editor":"tWkdx","relativeContainer":"y-Iq9","content":"EGyNq","triangle":"wXFZ1","left":"XNaGD","right":"buaBz"};